import { RelatedPart } from "./related-part"

export class Part {
  id: number
  primary_key: string
  number: string
  make: string
  model: string
  description: string
  qty_on_hand: string
  net_weight: string
  klass: string
  supplier: string
  retail: string
  price: string
  core_charge: string
  hide_add_to_cart: string
  show_price_on_ihm: string
  image_reference: string
  alternates: string
  slug: string
  created_at: string
  updated_at: string
  images: string[]
  count: number
  related_parts: RelatedPart[]
  warranty: string
  valid_image: boolean
  constructor({
    klass = '',
    id = 0,
    primary_key = '',
    number = '',
    make = '',
    model = '',
    description = '',
    qty_on_hand = '',
    net_weight = '',
    supplier = '',
    retail = '',
    price = '',
    core_charge = '',
    hide_add_to_cart = '',
    show_price_on_ihm = '',
    alternates = '',
    slug = '',
    created_at = '',
    updated_at = '',
    images = [],
    count = 0,
    warranty = '',
    valid_image = false,
    ...rest
  }) {
    Object.assign(this, rest)
    this.klass = klass
    this.id  = id
    this.primary_key = primary_key
    this.number = number
    this.make = make
    this.model = model
    this.description = description
    this.qty_on_hand = qty_on_hand
    this.net_weight = net_weight
    this.supplier = supplier
    this.retail = retail
    this.price = price
    this.core_charge = core_charge
    this.hide_add_to_cart = hide_add_to_cart
    this.show_price_on_ihm = show_price_on_ihm
    this.image_reference = rest.image_reference
    this.alternates = alternates
    this.slug = slug
    this.created_at = created_at
    this.updated_at = updated_at
    this.images = images
    this.count = count
    this.related_parts = rest.related_parts && rest.related_parts.length ? rest.related_parts.map(x => new RelatedPart(x))  : []
    this.warranty = warranty
    this.valid_image = valid_image
  }

  handleBuildingImages(images: string) {
    if (images && images !== '') {
      let retImages = []
      const two = images.split('|')
      if (two && two.length) {
        two.forEach(img => {
          img = img.replace(/\s/g, '')
          retImages.push(img)
        })
      } else {
        retImages.push(images.replace(/\s/g, ''))
      }
      return retImages
    } else {
      return []
    }
  }
}
